import '../css/app.css'
import '../css/common.css'
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    AlertTriangle,
    Ban,
    Briefcase,
    Building2,
    Check,
    Clock3,
    CreditCard,
    Edit3,
    Landmark,
    Percent,
    Plus,
    RotateCcw,
    Save,
    Search,
    ShieldAlert,
    X,
} from 'lucide-react';
import axios from 'axios';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import { MessageModal } from '../component/modal/modal';
import { MerchantAuditView } from '../auditLog';

const emptyMerchant = makeMerchant({
    id: null,
    co_nm: '',
    mid: '',
    status: '정상',
    bank_nm: 'NH농협은행',
    accnt_no: '',
    accnt_nm: '',
    merchant_fee: '',
    terminal_fee_yn: 'N',
    terminal_fee_apply_type: 'NEXT_MONTH',
    blocked_cards: [],
});

const fallbackIssuers = ['국민', '신한', '삼성', '현대', '롯데', '하나', '우리', 'BC', 'NH'];

const mainTabs = [
    { key: 'merchantEdit', label: '가맹점 수정', icon: Building2 },
    { key: 'settlementCycle', label: '정산주기', icon: Clock3 },
    { key: 'pgInfo', label: 'PG정보', icon: Landmark },
    { key: 'manualCardPolicy', label: '수기결제 카드 정책', icon: CreditCard },
    { key: 'history', label: '변경이력', icon: Clock3 },
];

const editTabs = [
    { key: 'basic', label: '기본정보', icon: Building2 },
    { key: 'org', label: '영업조직/수수료', icon: Briefcase },
    { key: 'policy', label: '결제정책', icon: CreditCard },
];

const editSectionMeta = {
    basic: { label: '기본정보', description: 'MID, 상호명, 대표자, 연락처, 주소, 상태, 가맹점수수료, 정산계좌', fields: ['mid', 'co_nm', 'boss_nm', 'co_hp', 'co_addr', 'status', 'merchant_fee', 'bank_nm', 'accnt_no', 'accnt_nm'] },
    org: { label: '영업조직/수수료', description: '영업자 선택, 6단계 영업조직과 수수료, 적용 방식', fields: ['seller', 'branch', 'branch_fee', 'distributor', 'distributor_fee', 'agency', 'agency_fee', 'sales1', 'sales1_fee', 'sales2', 'sales2_fee', 'sales3', 'sales3_fee', 'apply_mode'] },
    policy: { label: '결제정책', description: '지갑, 수기노출, 단말기비 부과', fields: ['wallet_use_yn', 'sugi_expose', 'terminal_fee_yn', 'terminal_fee_apply_type'] },
};

const orgValueFields = [
    'branch',
    'branch_fee',
    'distributor',
    'distributor_fee',
    'agency',
    'agency_fee',
    'sales1',
    'sales1_fee',
    'sales2',
    'sales2_fee',
    'sales3',
    'sales3_fee',
];

const fieldLabels = {
    co_nm: '상호명',
    mid: '가맹점ID',
    status: '상태',
    boss_nm: '대표자명',
    co_hp: '연락처',
    co_addr: '사업장주소',
    seller: '영업자',
    branch: '지사',
    distributor: '총판',
    agency: '대리점',
    sales1: '영업자1',
    sales2: '영업자2',
    sales3: '영업자3',
    merchant_fee: '가맹점수수료',
    branch_fee: '지사수수료',
    distributor_fee: '총판수수료',
    agency_fee: '대리점수수료',
    sales1_fee: '영업자1수수료',
    sales2_fee: '영업자2수수료',
    sales3_fee: '영업자3수수료',
    bank_nm: '정산은행',
    accnt_no: '계좌번호',
    accnt_nm: '예금주',
    wallet_use_yn: '지갑 사용',
    sugi_expose: '수기노출',
    terminal_fee_yn: '단말기비 부과',
    blocked_cards: '불가카드',
    apply_mode: '수수료 적용 방식',
    terminal_fee_apply_type: '단말기비 적용 시점',
};

const applyModeLabels = {
    MIDNIGHT: '자정 반영',
    IMMEDIATE: '즉시 반영',

};

const devFullViewportStyle = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    height: 'calc(100vh - 52px)',
    marginTop: '52px',
    padding: '12px 14px 14px',
    backgroundColor: '#f1f5f9',
    overflow: 'hidden',
    boxSizing: 'border-box',
};

function makeMerchant(overrides) {
    return {
        id: 0,
        co_nm: '가맹점',
        mid: 'mid0000',
        status: '정상',
        settlement_status: '정산가능',
        boss_nm: '홍길동',
        co_hp: '010-1234-5678',
        co_addr: '서울특별시 강남구 테헤란로 123',
        bank_nm: 'NH농협은행',
        accnt_no: '351-****-6071',
        accnt_nm: '홍길동',
        seller: '김세일',
        seller_code: '',
        branch: '서울지사',
        distributor: '강남총판',
        agency: '역삼대리점',
        sales1: '',
        sales2: '',
        sales3: '',
        merchant_fee: '0.88',
        branch_fee: '4',
        distributor_fee: '5',
        agency_fee: '6',
        sales1_fee: '',
        sales2_fee: '',
        sales3_fee: '',
        wallet_use_yn: 'Y',
        sugi_expose: 'Y',
        terminal_fee_yn: 'N',
        blocked_cards: ['롯데', '현대'],
        apply_mode: 'MIDNIGHT',
        terminal_fee_apply_type: 'NEXT_MONTH',
        last_modified_at: '2026-05-27 18:21',
        ...overrides,
    };
}

function MerchantEditPreview() {
    const dispatch = useDispatch();
    const MyData = useSelector((state) => state.MyData);
    const [message, setMessage] = useState({ msg: '' });
    const [keyword, setKeyword] = useState('');
    const [searchType, setSearchType] = useState('가맹점명');
    const [listRows, setListRows] = useState([]);
    const [listLoading, setListLoading] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [mode, setMode] = useState('update');
    const [activeTab, setActiveTab] = useState('merchantEdit');
    const [formData, setFormData] = useState(emptyMerchant);
    const [issuers, setIssuers] = useState([]);
    const [agentOptions, setAgentOptions] = useState([]);
    const [manualPolicyMap, setManualPolicyMap] = useState({});
    const [manualPolicyLoading, setManualPolicyLoading] = useState(false);
    const [reviewModal, setReviewModal] = useState(false);
    const [reviewScope, setReviewScope] = useState(null);
    const [dangerModal, setDangerModal] = useState(false);

    useEffect(() => {
        dispatch(change_Current_Location('가맹점 수정 프리뷰'));
        dispatch(changeHeaderTitle({
            mainTitle: '개발자 프리뷰',
            subTitle: '가맹점 목록 + 수정 섹션'
        }));
    }, [dispatch]);


    const baseline = useMemo(() => {
        if (mode === 'create') return emptyMerchant;
        return listRows.find((row) => row.id === selectedId) ?? emptyMerchant;
    }, [listRows, mode, selectedId]);

    const changes = useMemo(() => getChanges(baseline, formData), [baseline, formData]);
    const canAccess = MyData?.role === 'SUPER';

    const hydrateMerchantOrgFees = async (merchant) => {
        if (!merchant?.seller_code || !merchant?.mid) return merchant;
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/merchant/up-list', {
                withCredentials: true,
                params: { code: merchant.seller_code, mid: merchant.mid },
            });
            const tmp = response?.data;
            if (tmp?.code >= 2000) return merchant;
            return {
                ...merchant,
                ...pickOrgValueFields(buildOrgFields(tmp?.data?.agent ?? [])),
            };
        } catch (error) {
            console.error(error);
            return merchant;
        }
    };

    const hydrateSelectedMerchant = async (merchant) => {
        const hydrated = await hydrateMerchantOrgFees(merchant);
        const orgFields = pickOrgValueFields(hydrated);
        setListRows((prev) => prev.map((row) => (row.id === hydrated.id ? { ...row, ...orgFields } : row)));
        setFormData((prev) => (prev.id === hydrated.id ? { ...prev, ...orgFields } : prev));
        return hydrated;
    };

    const fetchMerchants = async (targetPage = 1, append = false) => {
        setListLoading(true);
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/merchant', {
                withCredentials: true,
                params: buildMerchantSearchParams(targetPage, keyword, searchType),
            });
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                const rows = (tmp?.data?.merchant ?? []).map(mapApiMerchant);
                const pagination = tmp?.data?.pagination ?? {};
                const nextRows = append ? [...listRows, ...rows] : rows;
                setListRows(nextRows);
                setPage(targetPage);
                setTotalCount(pagination.total ?? nextRows.length);
                setHasMore(targetPage < (pagination.totalPages ?? 0));
                if (mode !== 'create') {
                    const selected = nextRows.find((row) => row.id === selectedId) ?? nextRows[0] ?? null;
                    setSelectedId(selected?.id ?? null);
                    setFormData(selected ?? emptyMerchant);
                    if (selected) hydrateSelectedMerchant(selected);
                }
            } else {
                setMessage({ msg: tmp?.msg || '가맹점 목록 조회에 실패했습니다.' });
                setListRows([]);
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: error?.response?.data?.msg || '가맹점 목록을 불러오는 중 오류가 발생했습니다.' });
            setListRows([]);
        } finally {
            setListLoading(false);
        }
    };

    const fetchAgentOptions = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/merchant/agent-list', {
                withCredentials: true,
            });
            const tmp = response?.data;
            setAgentOptions(tmp?.code < 2000 ? ((tmp?.data?.agent ?? []).sort((a, b) => a.auth_cd - b.auth_cd)) : []);
        } catch (error) {
            console.error(error);
            setAgentOptions([]);
        }
    };

    const selectAgent = async (agentCode) => {
        const selected = agentOptions.find((agent) => String(agent.code) === String(agentCode));
        const selectedName = selected?.nm ?? selected?.agent_name ?? '';
        if (!agentCode) {
            setFormData((prev) => ({ ...prev, seller_code: '', seller: '', ...buildOrgFields([]) }));
            return;
        }
        setFormData((prev) => ({
            ...prev,
            seller_code: agentCode,
            seller: selectedName || prev.seller,
        }));
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/merchant/up-list', {
                withCredentials: true,
                params: { code: agentCode },
            });
            const tmp = response?.data;
            if (tmp?.code >= 2000) {
                setMessage({ msg: tmp?.msg || '영업조직 조회에 실패했습니다.' });
                return;
            }
            const list = tmp?.data?.agent ?? [];
            const orgFields = buildOrgFields(list, selected);
            setFormData((prev) => ({
                ...prev,
                seller_code: agentCode,
                seller: selectedName || getAgentName(list[list.length - 1]) || prev.seller,
                ...orgFields,
            }));
        } catch (error) {
            console.error(error);
            setMessage({ msg: error?.response?.data?.msg || '영업조직을 불러오는 중 오류가 발생했습니다.' });
        }
    };

    const fetchManualCardPolicy = async (mid) => {
        if (!mid || mode === 'create') {
            setIssuers([]);
            setManualPolicyMap({});
            return;
        }
        setManualPolicyLoading(true);
        try {
            const [issuerResponse, policyResponse] = await Promise.all([
                axios.get(process.env.REACT_APP_API + '/api/card-info/issuers', { withCredentials: true }),
                axios.post(process.env.REACT_APP_API + '/api/merchant/manual-card-policy/list', { mid }, { withCredentials: true }),
            ]);
            const issuerTmp = issuerResponse?.data;
            const policyTmp = policyResponse?.data;
            setIssuers(issuerTmp?.code < 2000 ? (issuerTmp?.data ?? []) : []);
            if (policyTmp?.code >= 2000) {
                setMessage({ msg: policyTmp?.msg || '수기결제 카드 정책 조회에 실패했습니다.' });
                setManualPolicyMap({});
                return;
            }
            const nextMap = {};
            (policyTmp?.data?.policies ?? []).forEach((policy) => {
                if (!policy?.issuer) return;
                nextMap[policy.issuer] = {
                    issuer: policy.issuer,
                    enabled: true,
                    blocked_yn: policy.blocked_yn === 'Y' ? 'Y' : 'N',
                    max_installment: policy.max_installment ?? null,
                };
            });
            setManualPolicyMap(nextMap);
        } catch (error) {
            console.error(error);
            setMessage({ msg: error?.response?.data?.msg || '수기결제 카드 정책을 불러오는 중 오류가 발생했습니다.' });
            setIssuers([]);
            setManualPolicyMap({});
        } finally {
            setManualPolicyLoading(false);
        }
    };

    useEffect(() => {
        if (!canAccess) return;
        fetchMerchants(1, false);
        fetchAgentOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canAccess]);

    useEffect(() => {
        fetchManualCardPolicy(formData?.mid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData?.mid, mode]);

    const selectMerchant = (row) => {
        setSelectedId(row.id);
        setMode('update');
        setFormData(row);
        setActiveTab('merchantEdit');
        hydrateSelectedMerchant(row);
    };

    const startCreate = () => {
        setSelectedId(null);
        setMode('create');
        setFormData(emptyMerchant);
        setActiveTab('merchantEdit');
    };

    const updateField = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
    };

    const toggleCard = (issuer) => {
        setManualPolicyMap((prev) => {
            const current = prev[issuer] || { issuer, enabled: false, blocked_yn: 'N', max_installment: null };
            const nextBlocked = current.blocked_yn === 'Y' ? 'N' : 'Y';
            return {
                ...prev,
                [issuer]: { ...current, enabled: true, blocked_yn: nextBlocked, max_installment: nextBlocked === 'Y' ? null : current.max_installment },
            };
        });
    };

    const resetChanges = () => {
        setFormData(baseline);
        setMessage({ msg: '변경사항을 초기화했습니다.' });
    };

    const savePreview = () => {
        setReviewModal(false);
        setMessage({ msg: `${mode === 'create' ? '등록' : '수정'} 저장 흐름을 확인했습니다.` });
    };

    if (!canAccess) {
        return (
            <div className="content" id="contents" style={devFullViewportStyle}>
                <div className="intro-y box" style={{ padding: '20px', fontSize: '13px' }}>
                    SUPER 계정에서만 접근 가능한 개발자 프리뷰입니다.
                </div>
            </div>
        );
    }

    return (
        <div className="content" id="contents" style={devFullViewportStyle}>
            <MessageModal message={message} setMessage={setMessage} />

            <div className="intro-y box" style={{ padding: '14px 20px', marginBottom: '12px', flexShrink: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <select
                            id="merchant-preview-search-type"
                            name="merchant-preview-search-type"
                            className="form-select"
                            value={searchType}
                            onChange={(e) => setSearchType(e.target.value)}
                            style={toolbarSelectStyle}
                        >
                            {['가맹점명', '가맹점아이디'].map((item) => <option key={item} value={item}>{item}</option>)}
                        </select>
                        <div style={{ position: 'relative' }}>
                            <Search size={14} style={{ position: 'absolute', left: '9px', top: '8px', color: '#64748b' }} />
                            <input
                                className="form-control"
                                value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Enter') fetchMerchants(1, false); }}
                                placeholder={searchType === '가맹점아이디' ? 'MID 입력' : '가맹점명 입력'}
                                style={{ ...toolbarInputStyle('240px'), paddingLeft: '30px' }}
                            />
                        </div>
                        <button type="button" className="btn searchPayBtn" style={toolbarButtonStyle} onClick={() => fetchMerchants(1, false)}>
                            <Search size={14} />
                            조회
                        </button>
                    </div>
                    <button type="button" className="btn btn-primary" style={toolbarButtonStyle} onClick={startCreate}>
                        <Plus size={14} />
                        신규 등록
                    </button>
                </div>
            </div>

            <div className="intro-y box" style={{ padding: '14px 16px', flex: 1, minHeight: 0 }}>
                <div style={masterLayoutStyle}>
                    <MerchantList
                        rows={listRows}
                        selectedId={selectedId}
                        mode={mode}
                        loading={listLoading}
                        totalCount={totalCount}
                        hasMore={hasMore}
                        onSelect={selectMerchant}
                        onLoadMore={() => fetchMerchants(page + 1, true)}
                    />
                    <MerchantEditPane
                        mode={mode}
                        data={formData}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        updateField={updateField}
                        toggleCard={toggleCard}
                        issuers={issuers}
                        manualPolicyMap={manualPolicyMap}
                        manualPolicyLoading={manualPolicyLoading}
                        agentOptions={agentOptions}
                        selectAgent={selectAgent}
                        changes={changes}
                        resetChanges={resetChanges}
                        openReview={(scope = null) => {
                            setReviewScope(scope);
                            setReviewModal(true);
                        }}
                        openDanger={() => setDangerModal(true)}
                    />
                </div>
            </div>

            {reviewModal && (
                <ModalOverlay onClose={() => setReviewModal(false)}>
                    <div style={{ width: '720px', maxWidth: 'calc(100vw - 40px)' }}>
                        <ModalTitle title={reviewScope?.title || "변경사항 확인"} onClose={() => setReviewModal(false)} />
                        <ChangeTable changes={reviewScope?.changes || changes} />
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                            <button type="button" className="btn searchPayBtn" style={modalButtonStyle} onClick={() => setReviewModal(false)}>취소</button>
                            <button type="button" className="btn btn-primary" style={modalButtonStyle} onClick={savePreview}>
                                <Save size={14} />
                                저장
                            </button>
                        </div>
                    </div>
                </ModalOverlay>
            )}

            {dangerModal && (
                <ModalOverlay onClose={() => setDangerModal(false)}>
                    <div style={{ width: '440px', maxWidth: 'calc(100vw - 40px)' }}>
                        <ModalTitle title="가맹점 해지" onClose={() => setDangerModal(false)} />
                        <WarningBox>해지 처리 후 결제/정산/노출 정책이 중단될 수 있습니다.</WarningBox>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                            <button type="button" className="btn searchPayBtn" style={modalButtonStyle} onClick={() => setDangerModal(false)}>취소</button>
                            <button
                                type="button"
                                className="btn"
                                style={{ ...modalButtonStyle, color: '#fff', background: '#b91c1c', borderColor: '#b91c1c' }}
                                onClick={() => {
                                    setDangerModal(false);
                                    updateField('status', '해지대기');
                                    setMessage({ msg: '해지대기 상태로 변경했습니다.' });
                                }}
                            >
                                해지대기 처리
                            </button>
                        </div>
                    </div>
                </ModalOverlay>
            )}
        </div>
    );
}

function MerchantList({ rows, selectedId, mode, onSelect, loading, totalCount, hasMore, onLoadMore }) {
    const scrollRef = useRef(null);
    const sentinelRef = useRef(null);

    useEffect(() => {
        if (!hasMore || loading || !scrollRef.current || !sentinelRef.current) return undefined;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) onLoadMore();
        }, {
            root: scrollRef.current,
            rootMargin: '80px',
            threshold: 0,
        });
        observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, [hasMore, loading, onLoadMore]);

    return (
        <div style={{ minWidth: 0, border: '1px solid #e5e7eb', borderRadius: '4px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '92px minmax(0, 1fr) 74px', background: '#f8fafc', borderBottom: '1px solid #e5e7eb', fontSize: '12px', fontWeight: 800, color: '#334155' }}>
                {['MID', '가맹점명', '상태'].map((head) => <div key={head} style={listHeadStyle}>{head}</div>)}
            </div>
            <div ref={scrollRef} style={{ overflow: 'auto', flex: 1, minHeight: 0 }}>
                {loading && rows.length === 0 && <div style={{ padding: '18px', fontSize: '12px', color: '#64748b' }}>가맹점 목록 조회중...</div>}
                {!loading && rows.length === 0 && <div style={{ padding: '18px', fontSize: '12px', color: '#64748b' }}>조회된 가맹점이 없습니다.</div>}
                {rows.map((row) => {
                    const selected = mode === 'update' && selectedId === row.id;
                    return (
                        <button
                            key={row.id}
                            type="button"
                            onClick={() => onSelect(row)}
                            style={{
                                width: '100%',
                                display: 'grid',
                                gridTemplateColumns: '92px minmax(0, 1fr) 74px',
                                border: 0,
                                borderBottom: '1px solid #edf2f7',
                                background: selected ? '#eef6ff' : '#fff',
                                textAlign: 'left',
                                cursor: 'pointer',
                                fontSize: '12px',
                                color: '#111827',
                            }}
                        >
                            <Cell>{row.mid}</Cell>
                            <Cell strong>{row.co_nm}</Cell>
                            <Cell><StatusBadge label={row.status} /></Cell>
                        </button>
                    );
                })}
                <div ref={sentinelRef} style={{ height: '1px' }} />
            </div>
            <div style={{ borderTop: '1px solid #e5e7eb', padding: '9px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', color: '#64748b' }}>
                <span>{rows.length} / {totalCount || rows.length}건</span>
                <span>{loading && rows.length > 0 ? '조회중...' : hasMore ? '아래로 스크롤하면 더 조회됩니다.' : '마지막 목록입니다.'}</span>
            </div>
        </div>
    );
}

function MerchantEditPane({ mode, data, activeTab, setActiveTab, updateField, toggleCard, issuers, manualPolicyMap, manualPolicyLoading, agentOptions, selectAgent, changes, resetChanges, openReview, openDanger }) {
    return (
        <div style={{ minWidth: 0, border: '1px solid #e5e7eb', borderRadius: '4px', display: 'flex', flexDirection: 'column', minHeight: 0, background: '#fff', overflow: 'hidden' }}>
            <div style={{ padding: '10px 14px', borderBottom: '1px solid #e5e7eb', flexShrink: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center' }}>
                    <div style={{ minWidth: 0, display: 'flex', alignItems: 'center', gap: '9px' }}>
                        <h2 style={{ margin: 0, fontSize: '16px', fontWeight: 800 }}>{mode === 'create' ? '가맹점 등록' : '가맹점 수정'}</h2>
                        {mode === 'update' && <StatusBadge label={data.status} />}
                        <span style={{ fontSize: '12px', color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {mode === 'create' ? '업무 단위별 입력' : data.co_nm + ' / ' + data.mid}
                        </span>
                    </div>
                    <div style={{ fontSize: '12px', color: changes.length > 0 ? '#111827' : '#64748b', fontWeight: changes.length > 0 ? 800 : 500 }}>
                        {changes.length > 0 ? '전체 변경 ' + changes.length + '건' : '변경 없음'}
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', gap: '2px', overflowX: 'auto', padding: '0 12px', borderBottom: '1px solid #e5e7eb', flexShrink: 0 }}>
                {mainTabs.map((tab) => {
                    const Icon = tab.icon;
                    const active = activeTab === tab.key;
                    return (
                        <button key={tab.key} type="button" onClick={() => setActiveTab(tab.key)} style={{ height: '36px', padding: '0 9px', border: 0, borderBottom: active ? '2px solid #111827' : '2px solid transparent', background: 'transparent', color: active ? '#111827' : '#64748b', fontSize: '12px', fontWeight: active ? 800 : 500, display: 'flex', alignItems: 'center', gap: '5px', whiteSpace: 'nowrap' }}>
                            <Icon size={14} />
                            {tab.label}
                        </button>
                    );
                })}
            </div>

            <div style={{ padding: '10px 12px', overflow: 'hidden', flex: 1, minHeight: 0 }}>
                {activeTab === 'merchantEdit' && (
                    <div style={{ height: '100%', minHeight: 0, overflow: 'auto', paddingRight: '2px' }}>
                        <div style={editPanelGridStyle}>
                            <EditUnitPanel
                                tabKey="basic"
                                data={data}
                                updateField={updateField}
                                changes={changes}
                                openReview={openReview}
                            />
                            <EditUnitPanel
                                tabKey="org"
                                data={data}
                                updateField={updateField}
                                changes={changes}
                                openReview={openReview}
                                agentOptions={agentOptions}
                                selectAgent={selectAgent}
                            />
                            <EditUnitPanel
                                tabKey="policy"
                                data={data}
                                updateField={updateField}
                                changes={changes}
                                openReview={openReview}
                            />
                            <DangerPanel onOpen={openDanger} style={{ gridColumn: '1 / -1' }} />
                        </div>
                    </div>
                )}

                {activeTab === 'settlementCycle' && <SettlementCycleView mid={data?.mid} />}
                {activeTab === 'pgInfo' && <PgInfoView mid={data?.mid} />}
                {activeTab === 'manualCardPolicy' && <ManualCardPolicyPanel editingSection="cards" setEditingSection={() => { }} issuers={issuers} manualPolicyMap={manualPolicyMap} manualPolicyLoading={manualPolicyLoading} toggleCard={toggleCard} />}
                {activeTab === 'history' && (data?.mid ? <MerchantAuditView mid={data.mid} showFilterChip={false} /> : <EmptyState text="가맹점을 선택하면 실제 변경이력을 조회합니다." />)}
            </div>

            <div style={{ padding: '9px 12px', borderTop: '1px solid #e5e7eb', flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', background: '#fff' }}>
                <div style={{ fontSize: '12px', color: changes.length > 0 ? '#111827' : '#64748b', fontWeight: changes.length > 0 ? 800 : 500 }}>
                    {changes.length > 0 ? '전체 변경 ' + changes.length + '건' : '변경사항 없음'}
                </div>
                <div style={{ display: 'flex', gap: '6px' }}>
                    <button type="button" className="btn searchPayBtn" style={smallButtonStyle} disabled={changes.length === 0} onClick={resetChanges}>
                        <RotateCcw size={14} />
                        전체 취소
                    </button>
                    <button type="button" className="btn searchPayBtn" style={smallButtonStyle} disabled={changes.length === 0} onClick={() => openReview()}>
                        <Save size={14} />
                        전체 저장 확인
                    </button>
                </div>
            </div>
        </div>
    );
}

function EditUnitPanel({ tabKey, data, updateField, changes, openReview, style, agentOptions, selectAgent }) {
    const tab = editTabs.find((item) => item.key === tabKey) || editTabs[0];
    const meta = editSectionMeta[tabKey] || editSectionMeta.basic;
    const Icon = tab.icon;
    const sectionChanges = changes.filter((change) => meta.fields.includes(change.key));
    const openSectionReview = () => openReview({
        title: meta.label + ' 저장 전 확인',
        changes: sectionChanges,
    });

    return (
        <div style={{ ...style, border: '1px solid #e5e7eb', borderRadius: '4px', background: '#fff', overflow: 'hidden' }}>
            <div style={{ minHeight: '44px', padding: '9px 10px', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', background: '#f8fafc' }}>
                <div style={{ minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#111827', fontSize: '13px', fontWeight: 800 }}>
                        <Icon size={15} />
                        <span>{meta.label}</span>
                    </div>
                    <div style={{ marginTop: '2px', color: '#64748b', fontSize: '11px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{meta.description}</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                    <span style={{ fontSize: '11px', color: sectionChanges.length > 0 ? '#1d4ed8' : '#64748b', fontWeight: sectionChanges.length > 0 ? 800 : 500 }}>
                        {sectionChanges.length > 0 ? sectionChanges.length + '건' : '없음'}
                    </span>
                    <button type="button" className="btn btn-primary" style={smallButtonStyle} disabled={sectionChanges.length === 0} onClick={openSectionReview}>저장 확인</button>
                </div>
            </div>
            <div style={{ padding: '10px' }}>
                <MerchantEditSection activeEditTab={tabKey} data={data} updateField={updateField} agentOptions={agentOptions} selectAgent={selectAgent} />
            </div>
        </div>
    );
}

function MerchantEditSection({ activeEditTab, data, updateField, agentOptions = [], selectAgent }) {
    if (activeEditTab === 'org') {
        const orgRows = [
            { label: '지사', nameKey: 'branch', feeKey: 'branch_fee' },
            { label: '총판', nameKey: 'distributor', feeKey: 'distributor_fee' },
            { label: '대리점', nameKey: 'agency', feeKey: 'agency_fee' },
            { label: '영업자1', nameKey: 'sales1', feeKey: 'sales1_fee' },
            { label: '영업자2', nameKey: 'sales2', feeKey: 'sales2_fee' },
            { label: '영업자3', nameKey: 'sales3', feeKey: 'sales3_fee' },
        ];
        return (
            <div style={{ display: 'grid', gap: '12px' }}>
                <AgentSelectField label="영업조직 선택" value={data.seller_code || ''} displayValue={data.seller} options={agentOptions} onChange={selectAgent} />
                <div style={{ display: 'grid', gap: '8px' }}>
                    {orgRows.map((row) => (
                        <div key={row.nameKey} style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(130px, 0.45fr)', gap: '8px', alignItems: 'end' }}>
                            <TextField label={row.label} value={data[row.nameKey]} editable={false} onChange={() => { }} />
                            <NumberField label={row.label + '수수료'} value={data[row.feeKey]} editable onChange={(v) => updateField(row.feeKey, v)} />
                        </div>
                    ))}
                </div>
                <div>
                    <div style={{ fontSize: '12px', fontWeight: 800, color: '#475569', marginBottom: '6px' }}>수수료 적용 방식</div>
                    <SegmentedControl disabled={false} value={data.apply_mode} onChange={(v) => updateField('apply_mode', v)} />
                    {data.apply_mode === 'IMMEDIATE' && <WarningBox>즉시 적용은 영업조직 수수료 관련 항목에만 해당합니다. 그 외 항목은 저장 즉시 반영됩니다.</WarningBox>}
                </div>
            </div>
        );
    }

    if (activeEditTab === 'policy') {
        return (
            <div style={{ display: 'grid', gap: '12px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '8px' }}>
                    <ToggleField label="지갑 사용" value={data.wallet_use_yn} editable onChange={(v) => updateField('wallet_use_yn', v)} />
                    <ToggleField label="수기노출" value={data.sugi_expose} editable onChange={(v) => updateField('sugi_expose', v)} />
                    <ToggleField label="단말기비 부과" value={data.terminal_fee_yn} editable onChange={(v) => updateField('terminal_fee_yn', v)} />
                </div>
                {data.terminal_fee_yn === 'Y' && (
                    <div style={{ padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: '4px', background: '#f8fafc' }}>
                        <div style={{ fontSize: '12px', fontWeight: 800, color: '#475569', marginBottom: '8px' }}>단말기비 적용 시점</div>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '12px', marginBottom: '6px', cursor: 'pointer' }}>
                            <input type="radio" checked={data.terminal_fee_apply_type === 'CURRENT_MONTH'} onChange={() => updateField('terminal_fee_apply_type', 'CURRENT_MONTH')} />
                            이번달부터 부과
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '12px', cursor: 'pointer' }}>
                            <input type="radio" checked={data.terminal_fee_apply_type !== 'CURRENT_MONTH'} onChange={() => updateField('terminal_fee_apply_type', 'NEXT_MONTH')} />
                            다음달부터 부과
                        </label>
                    </div>
                )}
            </div>
        );
    }

    return (
        <FieldGrid>
            <TextField label="가맹점ID" value={data.mid} editable onChange={(v) => updateField('mid', v)} />
            <TextField label="상호명" value={data.co_nm} editable onChange={(v) => updateField('co_nm', v)} />
            <TextField label="대표자명" value={data.boss_nm} editable onChange={(v) => updateField('boss_nm', v)} />
            <TextField label="연락처" value={data.co_hp} editable onChange={(v) => updateField('co_hp', v)} />
            <SelectField label="상태" value={data.status} options={['정상', '정산보류', '해지대기']} editable onChange={(v) => updateField('status', v)} />
            <NumberField label="가맹점수수료" value={data.merchant_fee} editable onChange={(v) => updateField('merchant_fee', v)} />
            <SelectField label="정산은행" value={data.bank_nm} options={['NH농협은행', '국민은행', '신한은행', '우리은행']} editable onChange={(v) => updateField('bank_nm', v)} />
            <TextField label="계좌번호" value={data.accnt_no} editable onChange={(v) => updateField('accnt_no', v)} />
            <TextField label="예금주" value={data.accnt_nm} editable onChange={(v) => updateField('accnt_nm', v)} />
            <TextField label="사업장주소" value={data.co_addr} editable onChange={(v) => updateField('co_addr', v)} wide />
        </FieldGrid>
    );
}

function SettlementCycleView({ mid }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notice, setNotice] = useState('');
    const [form, setForm] = useState({ settlement_cycle: 'D0', fr_dt: '', realtime_st_yn: 'N', realtime_delay_tm: '' });

    useEffect(() => {
        setForm({ settlement_cycle: 'D0', fr_dt: '', realtime_st_yn: 'N', realtime_delay_tm: '' });
        setNotice('');
        if (!mid) return;
        setLoading(true);
        axios.get(process.env.REACT_APP_API + '/api/merchant/settlement-info', {
            withCredentials: true,
            params: { mid },
        }).then((response) => {
            const tmp = response?.data;
            setRows(tmp?.code < 2000 ? (tmp?.data?.merchant ?? []) : []);
        }).catch(() => setRows([])).finally(() => setLoading(false));
    }, [mid]);

    const updateForm = (key, value) => {
        setForm((prev) => {
            const nextForm = { ...prev, [key]: value };
            if (key === 'realtime_st_yn' && value === 'N') nextForm.realtime_delay_tm = '';
            if (key === 'realtime_delay_tm' && value !== '') {
                const num = Number(value);
                nextForm.realtime_delay_tm = Number.isNaN(num) ? '' : String(Math.max(5, Math.min(59, num)));
            }
            return nextForm;
        });
    };

    if (!mid) return <EmptyState text="가맹점을 선택하면 정산주기를 조회합니다." />;

    return (
        <div style={{ display: 'grid', gap: '12px' }}>
            <FormPanel
                title="정산주기 등록/변경"
                icon={Clock3}
                actionText="등록 확인"
                onAction={() => setNotice('정산주기 등록 요청 형식을 확인했습니다. dev 화면에서는 저장 API를 호출하지 않습니다.')}
                onReset={() => {
                    setForm({ settlement_cycle: 'D0', fr_dt: '', realtime_st_yn: 'N', realtime_delay_tm: '' });
                    setNotice('');
                }}
            >
                <FormGrid columns={4}>
                    <FormSelect label="정산주기" value={form.settlement_cycle} onChange={(v) => updateForm('settlement_cycle', v)} options={settlementCycleOptions} />
                    <FormInput label="적용일자" value={form.fr_dt} onChange={(v) => updateForm('fr_dt', onlyDateDigits(v))} placeholder="YYYYMMDD" />
                    <FormSelect label="즉시여부" value={form.realtime_st_yn} onChange={(v) => updateForm('realtime_st_yn', v)} options={[{ value: 'N', label: 'N' }, { value: 'Y', label: 'Y' }]} />
                    <FormInput label="정산지연분" type="number" value={form.realtime_delay_tm} onChange={(v) => updateForm('realtime_delay_tm', v)} placeholder="5~59" disabled={form.realtime_st_yn !== 'Y'} />
                </FormGrid>
                {notice && <InlineNotice>{notice}</InlineNotice>}
            </FormPanel>

            <DataPanel title="정산주기 조회 결과" loading={loading} rowsLength={rows.length} emptyText="조회된 정산주기가 없습니다.">
                <SimpleDataTable headers={['시작일자', '종료일자', '정산주기', '즉시여부', '정산지연분']} rows={rows.map((row) => [row.fr_dt, row.to_dt, row.settlement_cycle, row.realtime_st_yn, row.realtime_delay_tm])} />
            </DataPanel>
        </div>
    );
}

function PgInfoView({ mid }) {
    const [rows, setRows] = useState([]);
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notice, setNotice] = useState('');
    const initialPgForm = { pg_cd: '', svc_prdt_cd: '', fr_dt: '', cat_id: '', pg_license_key: '', fee: '', pg_key_in_ci: '', org_fee: '', org_settlement_cycle: 'D0', self_payment: 'N', self_realtime_fee: '', force_realtime: false };
    const [form, setForm] = useState(initialPgForm);

    useEffect(() => {
        setForm(initialPgForm);
        setNotice('');
        if (!mid) return;
        setLoading(true);
        axios.get(process.env.REACT_APP_API + '/api/merchant/pg-info', {
            withCredentials: true,
            params: { mid },
        }).then((response) => {
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setRows(tmp?.data?.merchant ?? []);
                setReservations(tmp?.data?.reservations ?? []);
            } else {
                setRows([]);
                setReservations([]);
            }
        }).catch(() => {
            setRows([]);
            setReservations([]);
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mid]);

    const updateForm = (key, value) => {
        setForm((prev) => {
            const nextForm = { ...prev, [key]: value };
            if (key === 'pg_cd' && value !== '04' && ['08', '11'].includes(nextForm.svc_prdt_cd)) nextForm.svc_prdt_cd = '';
            if (key === 'self_payment' && value !== 'Y') nextForm.self_realtime_fee = '';
            return nextForm;
        });
    };

    if (!mid) return <EmptyState text="가맹점을 선택하면 PG정보를 조회합니다." />;

    const paymentOptions = [
        { value: '', label: '선택' },
        { value: '01', label: '카드수기' },
        { value: '03', label: 'SMS수기' },
        ...(form.pg_cd === '04' ? [{ value: '08', label: 'SMS인증' }] : []),
        { value: '10', label: '단말기(IC)' },
        ...(form.pg_cd === '04' ? [{ value: '11', label: 'URL인증결제' }] : []),
    ];

    return (
        <div style={{ display: 'grid', gap: '12px' }}>
            <FormPanel
                title="PG정보 등록/변경"
                icon={Landmark}
                actionText="등록 확인"
                onAction={() => setNotice('PG정보 등록 요청 형식을 확인했습니다. dev 화면에서는 저장 API를 호출하지 않습니다.')}
                onReset={() => {
                    setForm(initialPgForm);
                    setNotice('');
                }}
            >
                <FormGrid columns={4}>
                    <FormSelect label="PG사" value={form.pg_cd} onChange={(v) => updateForm('pg_cd', v)} options={pgOptions} />
                    <FormSelect label="결제수단" value={form.svc_prdt_cd} onChange={(v) => updateForm('svc_prdt_cd', v)} options={paymentOptions} />
                    <FormInput label="적용일자" value={form.fr_dt} onChange={(v) => updateForm('fr_dt', onlyDateDigits(v))} placeholder="YYYYMMDD" />
                    <FormToggle label="즉시 적용" checked={form.force_realtime} onChange={(v) => updateForm('force_realtime', v)} text="자정 예약 없이 반영" />
                    <FormInput label="PGMID" value={form.cat_id} onChange={(v) => updateForm('cat_id', v)} />
                    <FormInput label="PGKEY" value={form.pg_license_key} onChange={(v) => updateForm('pg_license_key', v)} />
                    <FormInput label="수수료" value={form.fee} onChange={(v) => updateForm('fee', v)} />
                    <FormSelect label="키인형태" value={form.pg_key_in_ci} onChange={(v) => updateForm('pg_key_in_ci', v)} options={pgKeyOptions} />
                    <FormInput label="상위수수료" value={form.org_fee} onChange={(v) => updateForm('org_fee', v)} />
                    <FormSelect label="상위정산주기" value={form.org_settlement_cycle} onChange={(v) => updateForm('org_settlement_cycle', v)} options={[{ value: 'D0', label: '당일' }, { value: 'D1', label: 'D+1' }]} />
                    <FormSelect label="자체즉결" value={form.self_payment} onChange={(v) => updateForm('self_payment', v)} options={[{ value: 'N', label: '미사용' }, { value: 'Y', label: '사용' }]} />
                    {form.self_payment === 'Y' && <FormInput label="실제 수수료" value={form.self_realtime_fee} onChange={(v) => updateForm('self_realtime_fee', v)} />}
                </FormGrid>
                {notice && <InlineNotice>{notice}</InlineNotice>}
            </FormPanel>

            {reservations.length > 0 && (
                <DataPanel title="예약된 PG 정보 변경 건" tone="warning" rowsLength={reservations.length}>
                    <SimpleDataTable headers={['적용 예정일', 'PG', '결제수단', 'PGMID', '수수료', '키인형태']} rows={reservations.map((row) => [row.apply_dt, formatPg(row.pg_cd), formatPayment(row.svc_prdt_cd), row.cat_id ?? row.pg_mid, row.fee, formatPgKey(row.pg_key_in_ci)])} />
                </DataPanel>
            )}

            <DataPanel title="PG정보 조회 결과" loading={loading} rowsLength={rows.length} emptyText="조회된 PG정보가 없습니다.">
                <SimpleDataTable headers={['PG사', '결제수단', '수수료', '키인형태', '상위수수료', '상위정산주기', 'PGMID', '자체즉결', '실제 수수료', '적용일자', '종료일자']} rows={rows.map((row) => [formatPg(row.pg_cd), formatPayment(row.svc_prdt_cd), row.fee, formatPgKey(row.pg_key_in_ci), row.org_fee, row.org_settlement_cycle, row.cat_id ?? row.pg_mid, row.self_realtime, row.self_realtime_fee, row.fr_dt, row.to_dt])} />
            </DataPanel>
        </div>
    );
}

function FormPanel({ title, icon: Icon, children, actionText, onAction, onReset }) {
    return (
        <div style={{ padding: '14px', border: '1px solid #e5e7eb', borderRadius: '4px', background: '#fff' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                    <Icon size={16} color="#334155" />
                    <h3 style={{ fontSize: '14px', fontWeight: 800, margin: 0 }}>{title}</h3>
                </div>
                <div style={{ display: 'flex', gap: '6px' }}>
                    <button type="button" className="btn searchPayBtn" style={smallButtonStyle} onClick={onReset}>취소</button>
                    <button type="button" className="btn btn-primary" style={smallButtonStyle} onClick={onAction}>{actionText}</button>
                </div>
            </div>
            {children}
        </div>
    );
}

function DataPanel({ title, children, loading = false, emptyText, tone = 'default', rowsLength = 0 }) {
    const borderColor = tone === 'warning' ? '#fde68a' : '#e5e7eb';
    return (
        <div style={{ padding: '14px', border: '1px solid ' + borderColor, borderRadius: '4px', background: '#fff' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 800, margin: '0 0 12px' }}>{title}</h3>
            {loading ? <EmptyState text="조회중..." /> : rowsLength === 0 ? <EmptyState text={emptyText || '조회된 데이터가 없습니다.'} /> : children}
        </div>
    );
}

function FormGrid({ children, columns = 2 }) {
    return <div style={{ display: 'grid', gridTemplateColumns: 'repeat(' + columns + ', minmax(0, 1fr))', gap: '10px' }}>{children}</div>;
}

function FormInput({ label, value, onChange, placeholder = '', type = 'text', disabled = false }) {
    return (
        <label style={fieldWrapStyle}>
            <span style={labelStyle}>{label}</span>
            <input type={type} className="form-control" style={{ ...inputStyle, backgroundColor: disabled ? '#f8fafc' : '#fff' }} value={value ?? ''} placeholder={placeholder} disabled={disabled} onChange={(e) => onChange(e.target.value)} />
        </label>
    );
}

function FormSelect({ label, value, options, onChange }) {
    return (
        <label style={fieldWrapStyle}>
            <span style={labelStyle}>{label}</span>
            <select className="form-select" style={{ ...inputStyle, backgroundColor: '#fff' }} value={value} onChange={(e) => onChange(e.target.value)}>
                {options.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
            </select>
        </label>
    );
}

function FormToggle({ label, checked, onChange, text }) {
    return (
        <label style={fieldWrapStyle}>
            <span style={labelStyle}>{label}</span>
            <button type="button" onClick={() => onChange(!checked)} style={{ height: '34px', borderRadius: '4px', border: '1px solid ' + (checked ? '#93c5fd' : '#d1d5db'), background: checked ? '#eff6ff' : '#fff', color: checked ? '#1d4ed8' : '#475569', fontSize: '12px', fontWeight: 800, cursor: 'pointer' }}>
                {checked ? text : '자정 예약'}
            </button>
        </label>
    );
}

function InlineNotice({ children }) {
    return <div style={{ marginTop: '10px', padding: '9px 10px', border: '1px solid #bfdbfe', borderRadius: '4px', background: '#eff6ff', color: '#1d4ed8', fontSize: '12px' }}>{children}</div>;
}

const settlementCycleOptions = ['D0', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D8', 'D9', 'D10'].map((value) => ({ value, label: value === 'D0' ? '당일' : value }));
const pgOptions = [{ value: '', label: '선택' }, { value: '04', label: '윈글로벌' }, { value: '22', label: '위즈페이' }, { value: '23', label: '위루트' }];
const pgKeyOptions = [{ value: '', label: '선택' }, { value: '01', label: '카유' }, { value: '02', label: '카유생' }, { value: '03', label: '카유생비' }, { value: '00', label: '단말기' }];

function onlyDateDigits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
}

function getAgentName(agent) {
    return agent?.agent_name ?? agent?.name ?? agent?.nm ?? '';
}

function getAgentFee(agent) {
    return agent?.agent_fee ?? agent?.fee ?? agent?.fee_rate ?? agent?.rate ?? '';
}

function normalizeFee(value) {
    return hasAgentValue(value) ? Number(value) : '';
}

function getAgentDepth(agent) {
    const code = agent?.agent_code ?? '';
    return code ? Math.floor(String(code).length / 2) : 0;
}

function getAgentAuth(agent) {
    return Number(agent?.auth_cd ?? agent?.authCd ?? agent?.auth ?? agent?.level ?? agent?.depth ?? 0) || getAgentDepth(agent);
}

function getAgentByAuth(list, authCd) {
    return (list ?? []).find((agent) => getAgentAuth(agent) === authCd) || null;
}

function hasAgentValue(value) {
    return value !== undefined && value !== null && value !== '';
}

function getComparableAgentName(agent) {
    return String(getAgentName(agent) || '').trim();
}

function isSameAgentByName(left, right) {
    const leftName = getComparableAgentName(left);
    const rightName = getComparableAgentName(right);
    return !!leftName && !!rightName && leftName === rightName;
}

function normalizeOrgRows(list, selectedAgent = null) {
    const rows = [...(list ?? [])];
    const auths = rows.map(getAgentAuth).filter(Boolean);
    const isDescendingAuth = auths.length >= 2 && auths[0] > auths[auths.length - 1];
    const selectedAuth = getAgentAuth(selectedAgent);
    const selectedIsFirst = selectedAuth > 1 && rows.length > 1 && isSameAgentByName(rows[0], selectedAgent);
    return isDescendingAuth || selectedIsFirst ? rows.reverse() : rows;
}

function buildOrgFields(list, selectedAgent = null) {
    const rows = normalizeOrgRows(list, selectedAgent);
    return {
        branch: getAgentName(rows[0]),
        branch_fee: normalizeFee(getAgentFee(rows[0])),
        distributor: getAgentName(rows[1]),
        distributor_fee: normalizeFee(getAgentFee(rows[1])),
        agency: getAgentName(rows[2]),
        agency_fee: normalizeFee(getAgentFee(rows[2])),
        sales1: getAgentName(rows[3]),
        sales1_fee: normalizeFee(getAgentFee(rows[3])),
        sales2: getAgentName(rows[4]),
        sales2_fee: normalizeFee(getAgentFee(rows[4])),
        sales3: getAgentName(rows[5]),
        sales3_fee: normalizeFee(getAgentFee(rows[5])),
    };
}

function pickOrgValueFields(source) {
    return orgValueFields.reduce((acc, key) => {
        acc[key] = source?.[key] ?? '';
        return acc;
    }, {});
}

function formatAgentOptionLabel(agent) {
    const authCd = getAgentAuth(agent);
    const type = authCd === 1 ? '지사' : authCd === 2 ? '총판' : authCd === 3 ? '대리점' : authCd === 4 ? '영업자1' : authCd === 5 ? '영업자2' : '영업자3';
    return '(' + type + ') ' + (agent.nm || agent.agent_name || agent.code || '');
}

function formatPg(value) {
    return value === '04' ? '윈글로벌' : value === '22' ? '위즈페이' : value === '23' ? '위루트' : value;
}

function formatPayment(value) {
    return value === '10' ? '단말기' : value === '11' ? 'URL인증' : value === '08' ? 'SMS인증' : value === '03' ? 'SMS수기' : value === '01' ? '카드수기' : value;
}

function formatPgKey(value) {
    return value === '01' ? '카유' : value === '02' ? '카유생' : value === '03' ? '카유생비' : value === '00' ? '단말기' : value;
}

function ManualCardPolicyPanel({ editingSection, setEditingSection, issuers, manualPolicyMap, manualPolicyLoading, toggleCard }) {
    return (
        <SectionPanel title="수기결제 카드정책" icon={Ban} sectionKey="cards" editingSection={editingSection} setEditingSection={setEditingSection} tone="warning" hideAction>
            {manualPolicyLoading && <div style={{ fontSize: '12px', color: '#64748b' }}>수기결제 카드정책 조회중...</div>}
            {!manualPolicyLoading && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))', gap: '8px' }}>
                    {(issuers.length > 0 ? issuers : fallbackIssuers).map((issuer) => {
                        const name = typeof issuer === 'string' ? issuer : (issuer.name || issuer.issuer || issuer.card_nm || '');
                        if (!name) return null;
                        const policy = manualPolicyMap[name];
                        const blocked = policy?.blocked_yn === 'Y';
                        const enabled = !!policy?.enabled;
                        return (
                            <button key={name} type="button" disabled={editingSection !== 'cards'} onClick={() => toggleCard(name)} style={cardButtonStyle(blocked, editingSection === 'cards')}>
                                {enabled ? (blocked ? '불가 ' : '허용 ') : '기본 '}{name}
                            </button>
                        );
                    })}
                </div>
            )}
            <div style={{ marginTop: '8px', fontSize: '11px', color: '#64748b' }}>카드사 목록과 정책은 실제 조회 API를 사용합니다. 변경은 이 dev 화면 안에서만 확인됩니다.</div>
        </SectionPanel>
    );
}

function SimpleDataTable({ headers, rows }) {
    if (!rows.length) return <EmptyState text="조회된 데이터가 없습니다." />;
    return (
        <div style={{ width: '100%', overflowX: 'auto' }}>
            <table style={{ width: '100%', minWidth: headers.length > 7 ? '980px' : '560px', borderCollapse: 'collapse', fontSize: '12px' }}>
                <thead><tr style={{ background: '#f8fafc', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #e5e7eb' }}>{headers.map((head) => <th key={head} style={thStyle}>{head}</th>)}</tr></thead>
                <tbody>{rows.map((row, idx) => <tr key={idx} style={{ borderBottom: '1px solid #e5e7eb' }}>{row.map((cell, cellIdx) => <td key={cellIdx} style={tdStyle}>{cell ?? '-'}</td>)}</tr>)}</tbody>
            </table>
        </div>
    );
}

function SectionPanel({ title, icon: Icon, sectionKey, editingSection, setEditingSection, children, tone = 'default', extraAction, hideAction = false }) {
    const editing = editingSection === sectionKey;
    const borderColor = tone === 'danger' ? '#fecaca' : tone === 'warning' ? '#fde68a' : '#e5e7eb';
    return (
        <div style={{ padding: '14px', border: `1px solid ${borderColor}`, borderRadius: '4px', background: '#fff' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                    <Icon size={16} color={tone === 'danger' ? '#b91c1c' : '#334155'} />
                    <h3 style={{ fontSize: '14px', fontWeight: 800, margin: 0 }}>{title}</h3>
                </div>
                <div style={{ display: 'flex', gap: '6px' }}>
                    {extraAction}
                    {!hideAction && (
                        <button type="button" className={editing ? 'btn btn-primary' : 'btn searchPayBtn'} style={smallButtonStyle} onClick={() => setEditingSection(editing ? '' : sectionKey)}>
                            {editing ? <Check size={14} /> : <Edit3 size={14} />}
                            {editing ? '완료' : '수정'}
                        </button>
                    )}
                </div>
            </div>
            {children}
        </div>
    );
}

function AgentSelectField({ label, value, displayValue, options, onChange }) {
    const hasCurrentValue = value && options.some((agent) => agent.code === value);
    return (
        <label style={fieldWrapStyle}>
            <span style={labelStyle}>{label}</span>
            <select className="form-select" style={{ ...inputStyle, backgroundColor: '#fff' }} value={hasCurrentValue ? value : ''} onChange={(e) => onChange?.(e.target.value)}>
                <option value="">{displayValue ? displayValue : '선택'}</option>
                {options.map((agent) => <option key={agent.code} value={agent.code}>{formatAgentOptionLabel(agent)}</option>)}
            </select>
        </label>
    );
}

function FieldGrid({ children }) {
    return <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 180px), 1fr))', gap: '10px' }}>{children}</div>;
}

function TextField({ label, value, editable, onChange, wide = false, type = 'text' }) {
    return (
        <label style={{ ...fieldWrapStyle, gridColumn: wide ? '1 / -1' : undefined }}>
            <span style={labelStyle}>{label}</span>
            <input type={type} className="form-control" style={{ ...inputStyle, backgroundColor: editable ? '#fff' : '#f8fafc' }} value={value ?? ''} readOnly={!editable} onChange={(e) => onChange(e.target.value)} />
        </label>
    );
}

function NumberField({ label, value, editable, onChange }) {
    return (
        <label style={fieldWrapStyle}>
            <span style={labelStyle}>{label}</span>
            <div style={{ position: 'relative' }}>
                <input type="number" className="form-control" style={{ ...inputStyle, paddingRight: '28px', backgroundColor: editable ? '#fff' : '#f8fafc' }} value={value ?? ''} readOnly={!editable} onChange={(e) => onChange(e.target.value)} />
                <span style={{ position: 'absolute', right: '10px', top: '8px', fontSize: '12px', color: '#64748b' }}>%</span>
            </div>
        </label>
    );
}

function SelectField({ label, value, options, editable, onChange }) {
    return (
        <label style={fieldWrapStyle}>
            <span style={labelStyle}>{label}</span>
            <select className="form-select" style={{ ...inputStyle, backgroundColor: editable ? '#fff' : '#f8fafc' }} value={value} disabled={!editable} onChange={(e) => onChange(e.target.value)}>
                {options.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
        </label>
    );
}

function ToggleField({ label, value, editable, onChange }) {
    const enabled = value === 'Y';
    return (
        <div style={fieldWrapStyle}>
            <span style={labelStyle}>{label}</span>
            <button type="button" disabled={!editable} onClick={() => onChange(enabled ? 'N' : 'Y')} style={{ height: '34px', borderRadius: '4px', border: `1px solid ${enabled ? '#93c5fd' : '#d1d5db'}`, background: enabled ? '#eff6ff' : '#f8fafc', color: enabled ? '#1d4ed8' : '#64748b', fontSize: '12px', fontWeight: 800, cursor: editable ? 'pointer' : 'default' }}>
                {enabled ? 'Y' : 'N'}
            </button>
        </div>
    );
}

function SegmentedControl({ value, onChange, disabled }) {
    const options = [
        { value: 'MIDNIGHT', label: '자정 예약' },
        { value: 'IMMEDIATE', label: '즉시 반영' },
    ];
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', border: '1px solid #d1d5db', borderRadius: '4px', overflow: 'hidden', marginBottom: '10px' }}>
            {options.map((item, idx) => {
                const active = value === item.value;
                return <button key={item.value} type="button" disabled={disabled} onClick={() => onChange(item.value)} style={{ height: '34px', border: 0, borderRight: idx < options.length - 1 ? '1px solid #d1d5db' : 0, background: active ? '#111827' : '#fff', color: active ? '#fff' : '#334155', fontSize: '12px', fontWeight: active ? 800 : 500 }}>{item.label}</button>;
            })}
        </div>
    );
}

function DangerPanel({ onOpen, style }) {
    return (
        <div style={{ ...style, padding: '12px 14px', border: '1px solid #fecaca', borderRadius: '4px', background: '#fffafa', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <ShieldAlert size={17} color="#b91c1c" />
                <div>
                    <div style={{ fontSize: '14px', fontWeight: 800, color: '#991b1b' }}>위험 작업</div>
                    <div style={{ fontSize: '12px', color: '#7f1d1d', marginTop: '3px' }}>가맹점 해지는 별도 확인 후 처리합니다.</div>
                </div>
            </div>
            <button type="button" className="btn" style={{ ...smallButtonStyle, color: '#b91c1c', borderColor: '#b91c1c' }} onClick={onOpen}>가맹점 해지</button>
        </div>
    );
}

function EmptyState({ text }) {
    return <div style={{ padding: '18px', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '12px', color: '#64748b', textAlign: 'center' }}>{text}</div>;
}

function HistoryPanel({ changes }) {
    return (
        <div style={{ display: 'grid', gap: '10px' }}>
            <HistoryRow time="2026-05-27 18:21" actor="관리자" text="정산은행 원문 조회" />
            <HistoryRow time="2026-05-26 09:40" actor="관리자" text="수기노출 Y 변경" />
            <HistoryRow time="2026-05-25 14:08" actor="관리자" text="가맹점수수료 0.88 등록" />
            {changes.length > 0 && <ChangeTable changes={changes} compact />}
        </div>
    );
}

function HistoryRow({ time, actor, text }) {
    return <div style={{ display: 'grid', gridTemplateColumns: '130px 64px 1fr', gap: '8px', fontSize: '12px', color: '#334155', padding: '9px 10px', border: '1px solid #e5e7eb', borderRadius: '4px' }}><span style={{ color: '#64748b' }}>{time}</span><strong>{actor}</strong><span>{text}</span></div>;
}

function WarningBox({ children }) {
    return <div style={{ marginTop: '10px', padding: '10px 12px', border: '1px solid #fecaca', background: '#fff5f5', borderRadius: '4px', color: '#b91c1c', fontSize: '12px', display: 'flex', gap: '8px', alignItems: 'center' }}><AlertTriangle size={15} /><span>{children}</span></div>;
}

function ChangeTable({ changes, compact = false }) {
    if (changes.length === 0) return <div style={{ padding: '18px', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '13px', color: '#64748b', textAlign: 'center' }}>변경사항 없음</div>;
    return (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: compact ? '12px' : '13px' }}>
            <thead><tr style={{ background: '#f8fafc', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #e5e7eb' }}><th style={thStyle}>항목</th><th style={thStyle}>변경 전</th><th style={thStyle}>변경 후</th></tr></thead>
            <tbody>{changes.map((change) => <tr key={change.key} style={{ borderBottom: '1px solid #e5e7eb' }}><td style={tdStyle}>{change.label}</td><td style={tdStyle}>{change.before}</td><td style={{ ...tdStyle, fontWeight: 800, color: '#111827' }}>{change.after}</td></tr>)}</tbody>
        </table>
    );
}

function StatusBadge({ label }) {
    const danger = label !== '정상';
    return <span style={{ padding: '2px 7px', borderRadius: '4px', fontSize: '11px', fontWeight: 800, background: danger ? '#fff5f5' : '#ecfdf3', color: danger ? '#b91c1c' : '#166534', border: `1px solid ${danger ? '#fecaca' : '#bbf7d0'}` }}>{label}</span>;
}

function Metric({ label, value, warn = false }) {
    return <div style={{ border: '1px solid #e5e7eb', borderRadius: '4px', padding: '7px 9px' }}><div style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px' }}>{label}</div><div style={{ fontSize: '12px', fontWeight: 800, color: warn ? '#b91c1c' : '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</div></div>;
}

function Cell({ children, strong = false }) {
    return <div style={{ padding: '10px 9px', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: strong ? 700 : 500 }}>{children}</div>;
}

function ModalOverlay({ children, onClose }) {
    return <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.35)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }} onClick={onClose}><div className="box" style={{ backgroundColor: '#fff', borderRadius: '6px', padding: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.18)' }} onClick={(e) => e.stopPropagation()}>{children}</div></div>;
}

function ModalTitle({ title, onClose }) {
    return <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}><h3 style={{ fontSize: '16px', fontWeight: 800, margin: 0 }}>{title}</h3><button type="button" onClick={onClose} style={{ border: 0, background: 'transparent', padding: '4px', cursor: 'pointer' }}><X size={18} /></button></div>;
}

function buildMerchantSearchParams(page, keyword, searchType) {
    const trimmed = keyword.trim();
    const params = { page, limit: 40 };
    if (!trimmed) return params;
    params.keyword = trimmed;
    if (searchType === '가맹점아이디') {
        params.mid = trimmed;
    } else {
        params.co_nm = trimmed;
    }
    return params;
}

function mapApiMerchant(source) {
    const hierarchy = source?.agent_hierarchy ?? [];
    const agentDepth = (agent) => Math.floor(((agent?.agent_code ?? '').length) / 2);
    const agentByDepth = (depth) => hierarchy.find((agent) => agentDepth(agent) === depth)
        ?? hierarchy.find((agent) => Number(agent?.auth_cd) === depth)
        ?? {};
    const lowestAgent = hierarchy.length > 0
        ? hierarchy.reduce((min, item) => {
            const itemLevel = Number(item?.level);
            const minLevel = Number(min?.level);
            if (!Number.isNaN(itemLevel) && !Number.isNaN(minLevel)) return itemLevel < minLevel ? item : min;
            return agentDepth(item) > agentDepth(min) ? item : min;
        }, hierarchy[0])
        : null;
    const orgFields = {
        branch: getAgentName(agentByDepth(1)),
        branch_fee: normalizeFee(getAgentFee(agentByDepth(1))),
        distributor: getAgentName(agentByDepth(2)),
        distributor_fee: normalizeFee(getAgentFee(agentByDepth(2))),
        agency: getAgentName(agentByDepth(3)),
        agency_fee: normalizeFee(getAgentFee(agentByDepth(3))),
        sales1: getAgentName(agentByDepth(4)),
        sales1_fee: normalizeFee(getAgentFee(agentByDepth(4))),
        sales2: getAgentName(agentByDepth(5)),
        sales2_fee: normalizeFee(getAgentFee(agentByDepth(5))),
        sales3: getAgentName(agentByDepth(6)),
        sales3_fee: normalizeFee(getAgentFee(agentByDepth(6))),
    };
    return makeMerchant({
        id: source?.id,
        co_nm: source?.co_nm ?? '',
        mid: source?.mid ?? '',
        status: source?.terminated_at ? '해지대기' : source?.use_yn === '중지' ? '정산보류' : '정상',
        settlement_status: source?.terminated_at ? '해지' : '정산가능',
        boss_nm: source?.boss_nm ?? '',
        co_hp: source?.co_hp_masked ?? source?.co_hp ?? '',
        co_addr: source?.co_addr ?? '',
        bank_nm: source?.bank_nm ?? '',
        accnt_no: source?.accnt_no_masked ?? source?.accnt_no ?? '',
        accnt_nm: source?.accnt_nm_masked ?? source?.accnt_nm ?? '',
        seller: getAgentName(lowestAgent),
        seller_code: lowestAgent?.agent_code ?? lowestAgent?.code ?? '',
        merchant_fee: source?.merchant_fee ?? '',
        ...orgFields,
        wallet_use_yn: source?.deposit_yn ?? 'N',
        sugi_expose: source?.sugi_expose ?? 'N',
        terminal_fee_yn: source?.terminal_fee_yn ?? 'N',
        terminal_fee_apply_type: source?.terminal_fee_apply_type ?? 'NEXT_MONTH',
        blocked_cards: source?.block_card ? String(source.block_card).split(',').filter(Boolean) : [],
        last_modified_at: source?.mod_dt ?? '',
        raw: source,
    });
}

function getChanges(before, after) {
    return Object.keys(fieldLabels)
        .filter((key) => formatValue(key, before[key]) !== formatValue(key, after[key]))
        .map((key) => ({ key, label: fieldLabels[key], before: formatValue(key, before[key]), after: formatValue(key, after[key]) }));
}

function formatValue(key, value) {
    if (key === 'blocked_cards') return (value ?? []).join(', ') || '없음';
    if (key === 'apply_mode') return applyModeLabels[value] ?? value;
    if (key === 'terminal_fee_apply_type') return value === 'CURRENT_MONTH' ? '이번달부터 부과' : '다음달부터 부과';
    return value ?? '';
}

const masterLayoutStyle = { display: 'grid', gridTemplateColumns: 'clamp(300px, 21vw, 430px) minmax(0, 1fr)', gap: '12px', alignItems: 'stretch', height: '100%', minHeight: 0, overflow: 'hidden' };
const editPanelGridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 500px), 1fr))', gap: '10px', alignItems: 'stretch' };
const toolbarInputStyle = (width) => ({ width, height: '30px', minHeight: '30px', padding: '0 10px', fontSize: '12px', border: '1px solid #d1d5db', borderRadius: '4px', boxSizing: 'border-box' });
const toolbarSelectStyle = { width: '120px', minWidth: '120px', height: '30px', minHeight: '30px', padding: '0 28px 0 12px', fontSize: '12px', border: '1px solid #d1d5db', borderRadius: '4px', boxSizing: 'border-box' };
const toolbarButtonStyle = { height: '30px', minHeight: '30px', padding: '0 11px', fontSize: '12px', display: 'inline-flex', alignItems: 'center', gap: '4px' };
const listHeadStyle = { padding: '9px', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
const fieldWrapStyle = { display: 'grid', gap: '5px', minWidth: 0 };
const labelStyle = { fontSize: '12px', fontWeight: 700, color: '#475569' };
const inputStyle = { height: '34px', fontSize: '13px', borderRadius: '4px' };
const smallButtonStyle = { height: '30px', minHeight: '30px', padding: '0 10px', fontSize: '12px', display: 'inline-flex', alignItems: 'center', gap: '4px' };
const modalButtonStyle = { height: '34px', minHeight: '34px', padding: '0 12px', fontSize: '12px', display: 'inline-flex', alignItems: 'center', gap: '5px' };
const thStyle = { padding: '9px 10px', textAlign: 'left', color: '#475569', fontWeight: 800 };
const tdStyle = { padding: '9px 10px', color: '#334155' };
const cardButtonStyle = (blocked, editable) => ({ height: '34px', border: `1px solid ${blocked ? '#dc3545' : '#d1d5db'}`, borderRadius: '4px', background: blocked ? '#fff5f5' : '#fff', color: blocked ? '#b91c1c' : '#334155', fontSize: '12px', fontWeight: blocked ? 700 : 500, cursor: editable ? 'pointer' : 'default', opacity: editable ? 1 : 0.88 });

export default MerchantEditPreview;
